export default __webpack_public_path__ + "static/media/apple.d58a180e.svg";